// extracted by mini-css-extract-plugin
export default {"reserve":"rocket_reserve__8UnkE","unreserve":"rocket_unreserve__EAYXv","badge":"rocket_badge__+7mlG"};